export const PERMISSIONS = {
  ROLE_VIEW: 'role.view',
  ROLE_MANAGE: 'role.manage',
  PERMISSION_VIEW: 'permission.view',
  ADMIN_VIEW: 'admin.view',
  ADMIN_MANAGE: 'admin.manage',
  PRODUCT_VIEW: 'product.view',
  PRODUCT_MANAGE: 'product.manage',
  USER_VIEW: 'user.view',
  USER_MANAGE: 'user.manage',
  ORDER_VIEW: 'order.view',
  ORDER_MANAGE: 'order.manage',
  SETTING_VIEW: 'setting.view',
  SETTING_MANAGE: 'setting.manage',
  VOUCHER_VIEW: 'voucher.view',
  VOUCHER_MANAGE: 'voucher.manage',
  VOUCHER_REDEMPTION_VIEW: 'voucher_redemption.view',
  WITHDRAW_VIEW: 'withdraw.view',
  WITHDRAW_MANAGE: 'withdraw.manage',
  NOTIFICATION_VIEW: 'notification.view',
  NOTIFICATION_MANAGE: 'notification.manage',
  NOTIFICATION_DELIVERY_VIEW: 'notification_delivery.view',
  NOTIFICATION_DELIVERY_RETRY: 'notification_delivery.retry',
  SCHOOL_VIEW: 'school.view',
  SCHOOL_MANAGE: 'school.manage',
} as const;

export type PermissionKey = keyof typeof PERMISSIONS;
export type Permission = (typeof PERMISSIONS)[PermissionKey];

// Permission mapping to features
export const PERMISSION_FEATURES: Record<Permission, string[]> = {
  'role.view': ['Daftar Role'],
  'role.manage': ['CRUD Role'],
  'permission.view': ['Daftar Permission'],
  'admin.view': ['Admin'],
  'admin.manage': ['Admin'],
  'product.view': ['Produk', 'Bank Soal', 'Klaim Produk'],
  'product.manage': ['Produk', 'Bank Soal', 'Klaim Produk'],
  'user.view': ['Pengguna', 'Mentor', 'Sesi Mentoring'],
  'user.manage': ['Pengguna', 'Mentor', 'Sesi Mentoring'],
  'order.view': ['Transaksi'],
  'order.manage': ['Transaksi'],
  'setting.view': ['Pengaturan'],
  'setting.manage': ['Pengaturan'],
  'voucher.view': ['Voucher'],
  'voucher.manage': ['Voucher'],
  'voucher_redemption.view': ['Penukaran Voucher'],
  'withdraw.view': ['Penarikan Saldo'],
  'withdraw.manage': ['Penarikan Saldo'],
  'notification.view': ['Notifikasi', 'Role Email Receiver (Pengaturan)'],
  'notification.manage': ['Notifikasi', 'Role Email Receiver (Pengaturan)'],
  'notification_delivery.view': ['Pengiriman Notifikasi'],
  'notification_delivery.retry': ['Pengiriman Notifikasi'],
  'school.view': ['Universitas'],
  'school.manage': ['Universitas'],
};
